import StButton from './StButton'

// 导出组件所需方法
export default {
    install: function(Vue){
        Vue.component('StButton',StButton)
    }
}